import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';

import {
  IamTableComponent,
  IamPeriodComponent,
  IamTreeSelectionComponent,
  CountyGeoComponent,
  TaxAuthorityComponent,
  DialogViewTvanUsingRegisterComponent,
  SigningComponent,
} from './components/entity';

@NgModule({
  declarations: [
    IamTableComponent,
    IamPeriodComponent,
    IamTreeSelectionComponent,
    CountyGeoComponent,
    DialogViewTvanUsingRegisterComponent,
    TaxAuthorityComponent,
    SigningComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    SharedModule,
    IamTableComponent,
    IamPeriodComponent,
    IamTreeSelectionComponent,
    CountyGeoComponent,
    DialogViewTvanUsingRegisterComponent,
    TaxAuthorityComponent,
    SigningComponent
  ]
})
export class EntitiesModule {
}
